// Ameen homepage — hero scroll explosion (lightened for performance: fewer particles, no blur)
(function(){
  if(!window.gsap || !document.querySelector('.hero')) return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  gsap.registerPlugin(ScrollTrigger);
  if(window.lenis){ lenis.on('scroll', ScrollTrigger.update); }

  const targets=[
    {x:-58,y:-38,z:320,r:-40,s:2.1},{x:54,y:-42,z:240,r:55,s:1.9},
    {x:-66,y:20,z:140,r:30,s:1.7},{x:62,y:30,z:360,r:-60,s:2.3},
    {x:-38,y:52,z:70,r:90,s:1.5},{x:38,y:54,z:200,r:-25,s:1.8},
    {x:-78,y:-8,z:420,r:120,s:2.6},{x:76,y:-4,z:100,r:-90,s:1.6},
    {x:-22,y:-56,z:180,r:20,s:1.6},{x:20,y:58,z:280,r:-110,s:2.0},
    {x:-50,y:-64,z:90,r:70,s:1.4},{x:56,y:12,z:350,r:-45,s:2.2},
    {x:-8,y:66,z:230,r:140,s:1.8},{x:10,y:-68,z:140,r:-150,s:1.7},
    {x:-72,y:50,z:300,r:-80,s:2.0},{x:72,y:48,z:160,r:100,s:1.7}
  ];
  const allSpices = gsap.utils.toArray('.spice');

  const mm = gsap.matchMedia();
  mm.add({isDesktop:'(min-width:761px)', isMobile:'(max-width:760px)'}, (ctx)=>{
    const isDesktop = ctx.conditions.isDesktop;
    const vw=window.innerWidth, vh=window.innerHeight;
    const count = isDesktop ? Math.min(10, allSpices.length) : Math.min(6, allSpices.length);
    allSpices.forEach((p,i)=>{ p.style.display = i<count ? '' : 'none'; });

    const tl=gsap.timeline({scrollTrigger:{trigger:'.hero', start:'top top', end:'bottom top', scrub:isDesktop?0.7:0.5}});
    tl.to('.hero__img',{scale:isDesktop?1.3:1.2, yPercent:8, ease:'none'},0);
    tl.to('.hero__content',{yPercent:-28, autoAlpha:0, ease:'power1.in', duration:.5},0);
    const spread = isDesktop?1:0.8;
    for(let i=0;i<count;i++){
      const el=allSpices[i], t=targets[i];
      const tx=t.x/100*vw*spread, ty=t.y/100*vh*spread, sc=t.s*(isDesktop?1:0.78);
      tl.fromTo(el,{x:0,y:0,z:0,rotate:0,scale:.35,autoAlpha:0},
        {x:tx,y:ty,z:t.z,rotate:t.r,scale:sc,autoAlpha:1,ease:'power2.out',duration:.55},0.05);
      tl.to(el,{autoAlpha:0,ease:'power1.in',duration:.3},0.6);
    }
  });

  if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    document.querySelector('.hero').addEventListener('pointermove', function(e){
      var cx=e.clientX/window.innerWidth-0.5, cy=e.clientY/window.innerHeight-0.5;
      gsap.to('.hero__img',{x:cx*-22,y:cy*-14,duration:0.9,ease:'power2.out',overwrite:'auto'});
    });
  }
})();
